enum CardActionPerformedBy {
  BANK = 'BANK',
  CUSTOMER = 'CUSTOMER',
  UNDEFINED = 'UNDEFINED',
}

export default CardActionPerformedBy;
